import {Injectable, NgZone} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {catchError, EMPTY, noop, Observable, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {environment} from '@environments/environment';

@Injectable()
export class UmpireHttpErrorInterceptor implements HttpInterceptor {
  constructor(private readonly _router: Router, private readonly _zone: NgZone) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === 404 && this._isUmpireAuthUrl(req)) {
          this._navigateToError('error');
        }

        if (error?.status === 500 && this._isUmpireAuthUrl(req)) {
          this._navigateToError('error/500');
        }

        return throwError(() => error);
      }),
    );
  }

  private _navigateToError(path: string) {
    this._zone.run(() =>
      this._router.navigateByUrl(path, {
        skipLocationChange: true,
      }),
    );
  }

  private _isUmpireAuthUrl(req: HttpRequest<unknown>): boolean {
    return req.url.includes(environment.clientConfig.apiUrls.umpire);
  }
}
